import { useEffect } from "react";
import { createRoutesFromElements, Route } from "react-router";
import CartRoute from "./routes/cartRoute.tsx";
import DashboardRoute from "./routes/dashboardRoute.tsx";
import { fetchInit } from "../stores/user/userSlice.ts";
import { useAppDispatch } from "../services/hooks.ts";
import Layout from "./layout.tsx";
import ProductPage from "../features/ProductPage/ProductPage.tsx";
import Delivery from "../features/Placeholders-footer/Delivery.tsx";
import Help from "../features/Placeholders-footer/Help.tsx";
import Leasing from "../features/Placeholders-footer/Leasing.tsx";
import AboutUs from "../features/Placeholders-footer/AboutUs.tsx";
import Statute from "../features/About/Statute.tsx";
import PageTitle from "../helpers/PageTitle.tsx";
import ScrollToTop from "../helpers/ScrollToTop.tsx";

export default function App() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchInit());
    }, []);

    return null
}

export const mainRoutes = createRoutesFromElements(
    <Route path="/" id="root" element={<PageTitle title="shop.main"><App /><ScrollToTop /><Layout /></PageTitle>}>
        <Route index element={<Landing />}></Route>
        {/* <Route path="statute" element={<Statute />}></Route>
                <Route path="privacy" element={<Privacy />}></Route>
                <Route path="contact" element={<Contact />}></Route> */}
        <Route handle={{ breadcrumb: () => 'mainCategory' }}>
            <Route path="product/:productName" handle={{ breadcrumb: () => 'singleProduct' }} element={<ProductPage />} />
        </Route>
        <Route path="product/:productName" handle={{ breadcrumb: () => 'singleProduct' }} element={<ProductPage />} />
        <Route path="delivery" handle={{ breadcrumb: "delivery" }} element={<Delivery />} />
        <Route path="help" handle={{ breadcrumb: "Pomoc" }} element={<Help />} />
        <Route path="leasing" handle={{ breadcrumb: "Leasing" }} element={<Leasing />} />
        <Route path="about-us" handle={{ breadcrumb: "O Romer" }} element={<AboutUs />} />
        <Route path="regulamin" handle={{ breadcrumb: "Regulamin" }} element={<Statute />} />
        {CartRoute}
        {DashboardRoute}
    </Route>)

function Landing() {
    return <div>Landing</div>
}